import React from 'react';
import TokensTable from '../../components/TokensTable';
import { StudioPage } from '../../components/StudioPage';

/**
 * 令牌管理页面容器
 * 修改时间：2026-06-12
 */
const Token = () => {
  return (
    <StudioPage className='studio-management-page'>
      <TokensTable />
    </StudioPage>
  );
};

export default Token;
